// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__tal6m {
  display: grid;
  grid-template-rows: repeat(8, 1fr);
  grid-template-columns: 1fr;
  position: relative;
  padding: 0rem 1rem;
  background: #ffffff8a;
  justify-items: center;
  align-items: center; }
  .styles_container__tal6m > * {
    margin: 1rem 2rem; }
    @media (max-width: 1700px) {
      .styles_container__tal6m > * {
        margin: 1rem 0.25rem;
        max-width: 90%; } }
  .styles_container__tal6m .styles_navContainer__vZF3k {
    position: absolute;
    height: 3rem;
    width: 100%;
    top: 0rem;
    left: 0rem;
    margin: 0rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Screen/ScreenSidePanel/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAoB;EACpB,mBAAmB,EAAA;EARrB;IAUI,iBAAiB,EAAA;ICVnB;MDAF;QAYM,oBAAoB;QACpB,cAAc,EAAA,EAEjB;EAfH;IAiBI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;IACV,YAAY,EAAA","sourcesContent":["@import \"src/modules/Core/styles/mixins.scss\";\n\n.container {\n  display: grid;\n  grid-template-rows: repeat(8, 1fr);\n  grid-template-columns: 1fr;\n  position: relative;\n  padding: 0rem 1rem;\n  background: #ffffff8a;\n  justify-items:center;\n  align-items: center;\n  & > * {\n    margin: 1rem 2rem;\n    @include respond-to(1700px) {\n      margin: 1rem 0.25rem;\n      max-width: 90%;\n    }\n  }\n  .navContainer {\n    position: absolute;\n    height: 3rem;\n    width: 100%;\n    top: 0rem;\n    left: 0rem;\n    margin: 0rem;\n  }\n}\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__tal6m`,
	"navContainer": `styles_navContainer__vZF3k`
};
export default ___CSS_LOADER_EXPORT___;
